export default {
      id: "free_breakfast-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.845ff42f.svg#free_breakfast",
      toString: function () {
        return this.url;
      }
    }